export const NOTIFICATION_TYPES = {
  ASSIGNED_TO_ACTION: 'assigned_to_action',
  BANK_VERIFICATION: 'bank_verification',
  CHANNEL_EVENT: 'channel_event',
  CHANNEL_MENTION: 'channel_mention',
  CHANNEL_REPLY: 'channel_reply',
  CHAT_REPLY: 'chat_reply',
  DIGIQUOTE_VIEW: 'digiquote_view',
  ESTIMATOR_ASSIGNMENT: 'assigned_as_estimator',
  INTEGRATION_ACTION_FAILURE: 'integration_action_failure',
  MANUAL_INPUT_COMPLETED: 'manual_input_completed',
  NEW_RFQ: 'new_rfq',
  NEW_QUOTE_FROM_EMAIL: 'new_quote_from_email',
  NEW_SUBQUOTE: 'new_subquote',
  PARTBOT_REPLY: 'partbot_reply',
  TASKS: 'tasks',
  THREAD_MENTION: 'thread_mention',
  SHARE_REINITIALIZATION_REQUEST: 'share_reinitialization_request',
  SHARE_INVITE_FAILED: 'share_invite_failed',
};

export const QUERY_PARAMS = {
  SEARCH_TERM: 'search',
  ORGANIZATION_IDS: 'orgs',
  DATE_MIN: 'datemin',
  DATE_MAX: 'datemax',
  PAGE: 'page',
  FILTER_OUT_ACKNOWLEDGED: 'unread',
  DATE_RANGE: 'daterange',
};
